<template>
    <div class="adjustment-preview mt-3">
        <h6 class="adjustment-preview__title">Anteprima premio (pro-rata)</h6>

        <div v-if="loading" class="text-muted">
            <b-spinner small class="mr-2"/>Calcolo in corso…
        </div>

        <b-alert v-else-if="errors.length" show variant="danger" class="mb-0">
            <ul class="mb-0 pl-3">
                <li v-for="(message, i) in errors" :key="i">{{ message }}</li>
            </ul>
        </b-alert>

        <div v-else-if="result">
            <table class="table table-sm table-bordered mb-2">
                <tbody>
                <tr><th>Premio netto</th><td class="text-right">{{ money(result.totals.net) }}</td></tr>
                <tr><th>Diritti</th><td class="text-right">{{ money(result.totals.diritti) }}</td></tr>
                <tr><th>Accessori</th><td class="text-right">{{ money(result.totals.accessori) }}</td></tr>
                <tr><th>Imponibile</th><td class="text-right">{{ money(result.totals.imponibile) }}</td></tr>
                <tr><th>Imposte</th><td class="text-right">{{ money(result.totals.taxes) }}</td></tr>
                <tr class="table-active">
                    <th>{{ result.net_delta < 0 ? 'Totale (credito)' : 'Totale (addebito)' }}</th>
                    <td class="text-right font-weight-bold">{{ money(result.net_delta) }}</td>
                </tr>
                </tbody>
            </table>
            <p class="text-muted small mb-0">Giorni residui: {{ result.remaining_days }}/{{ result.total_days }}</p>
        </div>

        <p v-else class="text-muted mb-0">Aggiungere o escludere veicoli, o aggiungere garanzie, per vedere il premio.</p>
    </div>
</template>

<script>
import axios from 'axios'
import debounce from 'lodash/debounce'

export default {
    name: 'AdjustmentPremiumPreview',
    props: {
        previewUrl: {type: String, required: true},
        policyId: {type: String, required: true},
        changes: {type: Object, required: true},
        adjustmentDate: {type: String, default: ''},
    },
    data() {
        return {loading: false, result: null, errors: []}
    },
    computed: {
        hasChanges() {
            const c = this.changes
            return (c.added && c.added.length) || (c.removed && c.removed.length) || (c.coverage_changes && c.coverage_changes.length)
        },
    },
    watch: {
        changes: {deep: true, handler() { this.scheduleFetch() }},
        adjustmentDate() { this.scheduleFetch() },
    },
    created() {
        this.scheduleFetch = debounce(this.fetch, 400)
    },
    methods: {
        money(value) {
            return new Intl.NumberFormat('it-IT', {style: 'currency', currency: 'EUR'}).format(Number(value) || 0)
        },
        async fetch() {
            this.errors = []
            if (!this.hasChanges || !this.adjustmentDate) {
                this.result = null
                return
            }
            this.loading = true
            try {
                const response = await axios.get(this.previewUrl, {
                    params: {
                        policy_id: this.policyId,
                        adjustment_date: this.adjustmentDate,
                        vehicles: JSON.stringify(this.changes),
                    },
                    headers: {'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json'},
                })
                const body = response.data
                this.result = body.data || body
            } catch (error) {
                this.result = null
                const data = error.response && error.response.data ? error.response.data : {}
                const messages = Object.values(data.errors || {}).flat()
                this.errors = messages.length ? messages : [data.message || 'Errore nel calcolo del premio.']
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style scoped>
.adjustment-preview__title {
    color: #2b3b9a;
    font-weight: bold;
}
</style>
